module.exports = __webpack_public_path__ + "img/happy-hour-texto-2.0fea4ca0.svg";